import isArray from 'lodash/isArray'
import assign from 'lodash/assign'
import {localize, app} from 'linksoft';

const Resx = localize('Common');

function createLink(urlName, args) {
    return `<a href="${app.url(urlName, args)}">${args.name}</a>`;
}

const templates = {

    download: function (e, urlName) {
        return `<a href="${app.url(urlName, e.value)}" title="${Resx.Common.Download}"><span class="fa fa-download"></span></a>`;
    },
    deleteItem: function (e) {
        return `<a data-table-delete="${e.value}" title="${Resx.Common.Delete}"><i class="fa fa-remove"></i></a>`;
    },

    percentage: function (e) {
        return `${e.value}&nbsp;%`;
    },

    /**
     * DEPRECATED!!! We use LookupColumn renderer now.
     * @param e
     * @returns {*|string}
     */
    lookup: function (e) {
        return (e.value ? e.value.name : e.value) || '-';
    },

    link: function (e, urlName, key) {
        if (isArray(e.value)) {
            return e.value.map(x => createLink(urlName, x)).join(e.formatString || '');
        }

        const args = {};
        if(typeof key === 'string'){
            args.id = this[key];
        }

        const dto = assign({}, (typeof e.value === 'object' ? e.value : {id: e.value, name: e.value}), args);
        return createLink(urlName, dto);
    },

    /**
     * DEPRECATED!!! We are using EnumColumn renderer now.
     * @param e
     * @param enumType
     * @returns {*}
     */
    enumText: function (e, enumType) {
        let enums = e.meta.settings.oInit.enums;
        let item = enums[enumType].find(x => x.id === e.value || x.value == e.value);
        return item ? item.text : null;
    }
};

export function addTemplates(objectWithTemplates) {
    assign(templates, objectWithTemplates);
}

export function getTemplate(templateName) {
    return templates[templateName];
}


// WEBPACK FOOTER //
// ./node_modules/linksoft-datatables/src/templates.js